import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

const PoliciesTable = lazy(
	() => import('@/features/air/multi-tenant/components/policies-table'),
)

export const Route = createFileRoute(
	'/_dashboard/multi-tenant/_layout/policies',
)({
	component: PoliciesTab,
	pendingComponent: RouteSkeleton,
})

function PoliciesTab() {
	return (
		<Suspense fallback={<TableFullSkeleton rows={10} />}>
			<PoliciesTable />
		</Suspense>
	)
}

function RouteSkeleton() {
	return <TableFullSkeleton rows={10} />
}
